import { Icon } from "@iconify/react";
import { numberFormatter } from "../../helper/method";
import BaseCard from "./BaseCard";
import BackgroundDot from "../svg/BackgroundDot";

export default function StatisticsCard({
  icon,
  number,
  title,
}: {
  icon: string;
  title: string;
  number: number;
}) {
  return (
    <BaseCard props={{ className: "flex-1 relative overflow-hidden" }}>
      <div className="w-full h-full absolute text-primary-100 top-0 right-0">
        <BackgroundDot />
      </div>
      <div className="flex flex-col gap-3">
        <span className="text-16-semi-bold text-grayscale-500">{title}</span>
        <span className="display-36-bold">{numberFormatter(number)}</span>
      </div>
      <div className="absolute top-1/2 left-6 text-secondary-600 rounded-full h-14 w-14 bg-secondary-50 flex-center -translate-y-1/2">
        <Icon icon={icon} className="w-6 h-6" />
      </div>
    </BaseCard>
  );
}
